import { useCallback } from 'react';

const useFileDownload = () => {
    const downloadBlob = useCallback((blob, filename) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, []);

    const downloadFromPromise = useCallback(async (promiseFactory, filename) => {
        const blob = await promiseFactory();
        downloadBlob(blob, filename);
    }, [downloadBlob]);

    return { downloadBlob, downloadFromPromise };
};

export default useFileDownload;
